module.exports = __webpack_public_path__ + "static/media/3_custom_slides.5ca9a777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/3_custom_slides.jpg
// module id = 310
// module chunks = 0